<script>
export default {
  props: {
    type: String,
    bordered: Boolean,
  },
};
</script>

<template>
  <div class="f-hint" :class="[type, bordered]">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.f-hint {
  display: flex;
  gap: 7px;
  padding: 12px 8px;
  border-left: 4px solid;
  border-left-color: var(--turquoise);
  background: rgba(239, 239, 238, 0.25);

  border-radius: 4px;
  color: #161615;

  &.bordered {
    border-top: 1px solid #bbbbb8;
    border-right: 1px solid #bbbbb8;
    border-bottom: 1px solid #bbbbb8;
    background-color: #ffffff;
  }

  &.negative {
    background-color: var(--statusNegative-a5);
    border-left-color: var(--statusNegative);
  }

  &.notice {
    border-left-color: var(--statusNotice);
  }
}

.dark-mode
{
  .f-hint {
  border-left-color: var(--primary);
  background: var(--white-a5);
  color: var(--white-a75);
  padding: 12px 8px;

  &.bordered {
    border-top: 1px solid #bbbbb8;
    border-right: 1px solid #bbbbb8;
    border-bottom: 1px solid #bbbbb8;
    background-color: #ffffff;
  }

  &.negative {
    background-color: var(--white-a10);
    border-left-color: var(--negative);
  }

  &.notice {
    border-left-color: var(--statusNotice);
  }
}
}
</style>